import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  Container,
  Stack,
  Avatar,
} from "@mui/material";
import FilePreviewDialog from "../../../Component/commen/FilePreviewDialog";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ReviewAndSubmit = ({ getValues, handleBack, files }) => {
  const { applicant, projectDetails, organization } = getValues || {};
  const [previewFile, setPreviewFile] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const API_URL = process.env.React_App_Api;
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const fileData = new FormData();
      let uploadedFiles = [];

      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          fileData.append("images", files[i]);
        }

        const folderName = `${
          getValues.applicant.fullName
        }${getValues.applicant.phoneNumber.slice(-4)}`;
        fileData.append("folderName", folderName);

        const uploadResponse = await axios.post(
          `${API_URL}/file/posts`,
          fileData
        );
        uploadedFiles = uploadResponse.data.files;
      }

      const submissionData = {
        ...getValues,
        projectDetails: {
          ...getValues.projectDetails,
          documents: uploadedFiles,
        },
      };

      const response = await axios.post(
        `${API_URL}/charity`,
        submissionData
      );
      navigate("/successfully-submitted");
      return response.data;
    } catch (error) {
      console.error("Error in Development Apply:", error);
      throw error;
    }
  };

  const renderDetailItem = (label, value) => (
    <>
      <Grid item xs={12} sm={4}>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
        <Typography>{value || "Not provided"}</Typography>
      </Grid>
    </>
  );

  return (
    <Container maxWidth="lg" sx={{ py: 3, textAlign: "start" }}>
      <Grid container spacing={3}>
        {/* Applicant Details Card */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 1, px: 4, height: "100%" }}>
            <Typography variant="h6" sx={{ color: "primary.main" }}>
              Applicant Details
            </Typography>
            <Divider sx={{ mb: 1 }} />

            <Grid container spacing={2}>
              {renderDetailItem("Full Name", applicant?.fullName)}
              {renderDetailItem("Phone Number", applicant?.phoneNumber)}
              {renderDetailItem("Email", applicant?.email)}
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={3} sx={{ p: 1, px: 4 }}>
            <Typography variant="h6" sx={{ color: "primary.main" }}>
              Project Details
            </Typography>
            <Divider sx={{ mb: 1 }} />

            <Grid container spacing={2}>
              {renderDetailItem("Project Name", projectDetails?.projectName)}

              <Grid item xs={12} container>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Project Type
                  </Typography>
                  <Typography>
                    {projectDetails?.projectType || "Not provided"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Amount Requested
                  </Typography>
                  <Typography>
                    {projectDetails?.amountRequested
                      ? `$${projectDetails.amountRequested}.00`
                      : "Not provided"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">
                  Project Description
                </Typography>
                <Typography>
                  {projectDetails?.projectDescription
                    ? `${projectDetails.projectDescription}`
                    : "Not provided"}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Organization Details Card */}
        <Grid item xs={12} md={12}>
          <Paper elevation={3} sx={{ p: 1, px: 4, height: "100%" }}>
            <Typography variant="h6" sx={{ color: "primary.main" }}>
              Organization Details
            </Typography>
            <Divider sx={{ mb: 1 }} />

            <Grid container spacing={2}>
              <Grid item xs={12} container>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Organization Name
                  </Typography>
                  <Typography>
                    {organization?.orgName || "Not provided"}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Organization Email
                  </Typography>
                  <Typography>
                    {organization?.orgEmail || "Not provided"}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Organization Phone
                  </Typography>
                  <Typography>
                    {organization?.orgPhone || "Not provided"}
                  </Typography>
                </Grid>
              </Grid>
              {renderDetailItem(
                "Address Line 1",
                organization?.address?.address1
              )}
              {renderDetailItem(
                "Address Line 2",
                organization?.address?.address2
              )}

              <Grid item xs={12} container>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    City
                  </Typography>
                  <Typography>
                    {organization?.address?.city || "Not provided"}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    State
                  </Typography>
                  <Typography>
                    {organization?.address?.state || "Not provided"}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Zip Code
                  </Typography>
                  <Typography>
                    {organization?.address?.zipCode || "Not provided"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Project Details Card */}

        {/* Files Section */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 1, px: 2 }}>
            <Typography variant="h6" sx={{ mb: 1, color: "primary.main" }}>
              Attached Files
            </Typography>
            <Divider sx={{ mb: 1 }} />

            {files.length > 0 ? (
              <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
                {files.map((file, index) => {
                  const fileName =
                    file.name.length > 10
                      ? `${file.name.substring(0, 7)}...${file.name
                          .split(".")
                          .pop()}`
                      : file.name;

                  return (
                    <Box
                      key={index}
                      sx={{
                        position: "relative",
                        width: 100,
                        height: 120,
                        mb: 2,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        onClick={() => {
                          if (file.type.startsWith("image/")) {
                            setPreviewFile(file);
                            setOpenPreview(true);
                          }
                        }}
                        sx={{
                          cursor: file.type.startsWith("image/")
                            ? "pointer"
                            : "default",
                          width: 100,
                          height: 100,
                          position: "relative",
                          "&:hover": {
                            opacity: file.type.startsWith("image/") ? 0.8 : 1,
                          },
                        }}
                      >
                        {file.type.startsWith("image/") ? (
                          <Avatar
                            src={URL.createObjectURL(file)}
                            variant="rounded"
                            sx={{ width: "100%", height: "100%" }}
                          />
                        ) : (
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: "100%",
                              height: "100%",
                              bgcolor: "grey.200",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <InsertDriveFileIcon color="action" />
                          </Avatar>
                        )}
                      </Box>

                      <Typography
                        variant="caption"
                        sx={{
                          mt: 0.5,
                          textAlign: "center",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {fileName}
                      </Typography>
                    </Box>
                  );
                })}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No files attached
              </Typography>
            )}
          </Paper>
        </Grid>

        {/* Buttons */}
        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{ minWidth: 120, textTransform: "none" }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{ minWidth: 120, textTransform: "none" }}
            >
              Submit
            </Button>
          </Box>
        </Grid>
      </Grid>

      <FilePreviewDialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        file={previewFile}
      />
    </Container>
  );
};

export default ReviewAndSubmit;
